/**
 * Markeri roka za poslove: zeleni / narandžasti / crveni
 * - Faza obaveštavanja (pre nego što je stranka obaveštena): 0–2 dana zeleno, 3–4 narandžasto, 5+ crveno
 * - Faza servisa (posle obaveštavanja): 0–10 dana zeleno, 11–20 narandžasto, 21+ crveno (do 30 dana zakonski)
 * Poslovi sa statusom Completed, Delivered, Archived, Finished, Cancelled nemaju marker.
 */

const RESOLVED_STATUSES = ['Completed', 'Delivered', 'Archived', 'Finished', 'Cancelled'];

/**
 * Broj kalendarskih dana između dva datuma (ceo broj).
 */
function daysBetween(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.floor((end - start) / (24 * 60 * 60 * 1000));
}

/**
 * Vraća marker za posao: boja, faza i label za tooltip.
 * @param {Object} job - posao sa createdAt i opciono clientNotifiedAt
 * @returns {{ color: 'green'|'orange'|'red', phase: 'obavestenje'|'servis', label: string, daysUsed: number } | null}
 */
export function getDeadlineMarker(job) {
  if (!job) return null;
  if (RESOLVED_STATUSES.includes(job.status)) return null;

  const now = new Date();
  const clientNotifiedAt = job.clientNotifiedAt ? new Date(job.clientNotifiedAt) : null;
  const createdAt = job.createdAt ? new Date(job.createdAt) : now;

  if (clientNotifiedAt) {
    // Faza servisa: od obaveštavanja stranke, 30 dana za završetak popravke (prikaz dana od 1)
    const days = daysBetween(clientNotifiedAt, now);
    const dayNum = Math.max(0, days) + 1; // 1-based za prikaz
    const servText = `Servis ${dayNum}. dan`;
    if (days >= 0 && days <= 10) return { color: 'green', phase: 'servis', daysUsed: days, label: `Servis: ${dayNum}. dan od obaveštavanja (1–10 zeleno)`, shortLabel: `${servText} (zel.)`, shortText: servText };
    if (days >= 11 && days <= 20) return { color: 'orange', phase: 'servis', daysUsed: days, label: `Servis: ${dayNum}. dan (11–20 narandžasto)`, shortLabel: `${servText} (nar.)`, shortText: servText };
    return { color: 'red', phase: 'servis', daysUsed: days, label: `Servis: ${dayNum}. dan (21–30 crveno, rok za završetak)`, shortLabel: `${servText} (crv.)`, shortText: servText };
  }

  // Faza obaveštavanja: od prijema posla, 5 radnih dana zakonski rok (prikaz dana od 1)
  const days = daysBetween(createdAt, now);
  const dayNum = Math.max(0, days) + 1; // 1-based za prikaz
  const obavText = `Nije obavešten, ${dayNum}. dan`;
  if (days >= 0 && days <= 2) return { color: 'green', phase: 'obavestenje', daysUsed: days, label: `Obaveštavanje: ${dayNum}. dan (1–2 zeleno)`, shortLabel: `${obavText} (zel.)`, shortText: obavText };
  if (days >= 3 && days <= 4) return { color: 'orange', phase: 'obavestenje', daysUsed: days, label: `Obaveštavanje: ${dayNum}. dan (3–4 narandžasto)`, shortLabel: `${obavText} (nar.)`, shortText: obavText };
  return { color: 'red', phase: 'obavestenje', daysUsed: days, label: `Obaveštavanje: ${dayNum}. dan (5+ crveno – obavestite stranku)`, shortLabel: `${obavText} (crv.)`, shortText: obavText };
}

export default getDeadlineMarker;
